import {protocolParentResolver, protocolResolver} from "@/app/routes/protocol.resolver";
import {guardProtocolsWatch} from "@/app/routes/guards/protocols-guard";

const NAME = 'Протоколы'

export const protocols = [
    {
        path: 'protocols',
        loadComponent: () => import('@components/protocols/protocols.component').then(c => c.ProtocolsComponent),
        canActivate: [guardProtocolsWatch],
        data: {
            breadcrumbs: [
                {name: 'Испытания', url: '/'},
                {name: NAME, url: null},
            ],
            title: NAME,
            reuse: true,
            searchString: true
        },

    },
    {
        path: 'protocols/:id',
        loadComponent: () => import('@components/protocols/create-protocols/protocol.component').then(c => c.ProtocolComponent),
        canActivate: [guardProtocolsWatch],
        resolve: {
            protocol: protocolResolver
        },
        children: [
            {
                path: 'common-info',
                loadComponent: () => import('@components/protocols/create-protocols/common-info/common-info.component').then(c => c.CommonInfoComponent),
                resolve: {
                    protocol: protocolParentResolver
                },
                data: {
                    breadcrumbs: [
                        {name: 'Испытания', url: '/'},
                        {name: NAME, url: '/protocols'},
                        {name: 'Общая информация', url: null},
                    ],
                    reuse: false
                },
            },
            {
                path: 'testings',
                loadComponent: () => import('@components/protocols/create-protocols/testings/testings.component').then(c => c.TestingsComponent),
                data: {
                    breadcrumbs: [
                        {name: 'Испытания', url: '/'},
                        {name: NAME, url: '/protocols'},
                        {name: 'Тестируемые', url: null},
                    ],
                },
            },
            {
                path: 'exercises',
                loadComponent: () => import('@components/protocols/create-protocols/exercises/exercises.component').then(c => c.ExercisesComponent),
                data: {
                    breadcrumbs: [
                        {name: 'Испытания', url: '/'},
                        {name: NAME, url: '/protocols'},
                        {name: 'Упражнения', url: null},
                    ],
                },
            },
            {
                path: 'results',
                loadComponent: () => import('@components/protocols/create-protocols/results/results.component').then(c => c.ResultsComponent),
                data: {
                    breadcrumbs: [
                        {name: 'Испытания', url: '/'},
                        {name: NAME, url: '/protocols'},
                        {name: 'Результаты', url: null},
                    ],
                },
            },
            {
                path: 'statuses',
                loadComponent: () => import('@components/protocols/create-protocols/status/status.component').then(c => c.StatusComponent),
                data: {
                    breadcrumbs: [
                        {name: 'Испытания', url: '/'},
                        {name: NAME, url: '/protocols'},
                        {name: 'Статус', url: null},
                    ],
                },
            },
        ],
        data: {
            breadcrumbs: [
                {name: NAME, url: '/protocols'},
                {name: 'Создание протокола', url: '/protocols/create'},
            ],
        },

    },

]
